import { useEffect, useRef } from 'react';

// Re-runs `fn` whenever the window/tab regains focus or becomes visible again.
// Keeps dashboard counters fresh after the user adds data on another page and
// returns (including browser back / bfcache restores) without a manual reload.
export default function useRefreshOnFocus(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const handler = () => { if (document.visibilityState === 'visible') ref.current(); };
    window.addEventListener('focus', handler);
    document.addEventListener('visibilitychange', handler);
    return () => {
      window.removeEventListener('focus', handler);
      document.removeEventListener('visibilitychange', handler);
    };
  }, []);
}
